<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { fade } from "svelte/transition";

    import { tabsNameContextToken } from "./constants";
    import TabsManager from "./TabsManager";

    export let name: string;
    export let tabsManager: TabsManager;
    const openedTab$ = tabsManager.openedTab$;
    const tabsName = getTypedContext(tabsNameContextToken);
</script>

<div
    role="tabpanel"
    aria-labelledby={`gw-tabcontrol-${tabsName}-${name}`}
    id={`gw-tab-${tabsName}-${name}`}
    class="gw-tabs-panel"
    class:gw-tabs-panel--opened={name === $openedTab$}
    in:fade={{ duration: 100 }}
>
    <slot />
</div>

<style>
    .gw-tabs-panel {
        visibility: hidden;
        opacity: 0;
        transition: opacity 100ms ease-in-out, visibility 0s linear 100ms;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    }
    .gw-tabs-panel--opened {
        visibility: visible;
        opacity: 1;
        position: relative;
        transition: opacity 100ms ease-in-out;
    }
</style>
